/**
 * HRSA FORHP rural ZIP-code approximation — ZIP-level eligibility lookup.
 * Generated by data_raw/build_forhp.R from the HRSA ZIP approximation file.
 *
 * Value: 1 = FORHP rural-eligible, 0 = not eligible.
 * FORHP rural is an ELIGIBILITY determination for federal rural-health grants,
 * derived by HRSA from RUCA + Road Ruggedness Scale + OMB metro/nonmetro — NOT
 * an independent rurality classification. Comparison/display only.
 *
 * Geography: 5-digit ZIP (joins on the app's `postcode` key, like RUCA/FAR).
 * License: US federal government work — public domain.
 *
 * Source: https://www.hrsa.gov/rural-health/about-us/what-is-rural/data-files
 */

let _data = null;
let _loadPromise = null;

export function loadForhpData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/forhp.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load FORHP data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getFORHPForZip(zip) {
  if (!_data || zip == null) return null;
  const key = String(zip).padStart(5, "0");
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const forhp = { loadForhpData, getFORHPForZip };
export default forhp;
